import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";

function LPEnquireForm() {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [levels, setLevels] = useState([]);
  const [courses, setCourses] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isThankYouVisible, setIsThankYouVisible] = useState(false);

  useEffect(() => {
    // Fetch States
    $.ajax({
      type: "GET",
      url: "https://insityapp.com/api/fetch-states",
      dataType: "json",
      success: function (response) {
        if (response?.states) setStates(response.states);
      },
      error: function (error) {
        console.error("Error fetching states:", error);
      },
    });

    // Fetch Levels
    const entity = "ISBMU";
    $.ajax({
      type: "GET",
      url: "https://insityapp.com/api/fetch-levels",
      data: { entity },
      dataType: "json",
      success: function (response) {
        if (response?.levels) setLevels(response.levels);
      },
      error: function (error) {
        console.error("Error fetching levels:", error);
      },
    });
  }, []);

  const fetchCities = (state) => {
    $.ajax({
      type: "GET",
      url: "https://insityapp.com/api/fetch-cities",
      data: { state },
      dataType: "json",
      success: function (response) {
        if (response?.cities) setCities(response.cities);
      },
      error: function (error) {
        console.error("Error fetching cities:", error);
      },
    });
  };

  const fetchCourses = (level) => {
    const entity = "ISBMU";
    const department = "all";
    $.ajax({
      type: "POST",
      url: "https://insityapp.com/api/fetch-courses",
      data: { level, entity, department },
      dataType: "json",
      success: function (response) {
        if (response?.courses) setCourses(response.courses);
      },
      error: function (error) {
        console.error("Error fetching courses:", error);
      },
    });
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    const form = event.target;
    const formData = new FormData(form);

    fetch(form.action, {
      method: form.method,
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          // Redirect to the thank you page after showing preloader
          window.location.href = "/thank-you.php"; // Update this path as needed
        } else {
          setIsSubmitting(false);
          alert("Form submission failed: " + data.message);
        }
      })
      .catch((error) => {
        setIsSubmitting(false);
        alert("An error occurred: " + error.message);
      });
  };

  return (
    <div className="enquireForm gradient-border col-xl-3 col-lg-4 col-md-6 col-sm-12 p-0">
      <h5>Enquire Now</h5>
      {/* Conditional Rendering */}
      {isSubmitting && (
        <div className="full-page-preloader">
          <div className="spinner-border text-primary" role="status"></div>
          <p>Submitting your details, please wait...</p>
        </div>
      )}
      <form
        action="https://isbmuniversity.com/submitLead.php"
        method="post"
        className="p-4"
        onSubmit={handleFormSubmit}
      >
        <div className="form-group">
          <input
            type="text"
            className="form-control mt-4 mb-3"
            id="name"
            name="name"
            placeholder="Enter your Name"
            required
          />
        </div>
        <div className="form-group">
          <input
            type="email"
            className="form-control mb-3"
            id="email"
            name="email"
            placeholder="Enter your Email"
            required
          />
        </div>
        <div className="form-group mb-3">
          <input
            type="number"
            max="9999999999"
            className="form-control"
            id="phone"
            name="phone"
            placeholder="Phone Number"
            required
          />
        </div>
        <div className="form-group mb-3">
          <select
            className="form-select"
            id="state"
            name="state"
            required
            onChange={(e) => fetchCities(e.target.value)}
          >
            <option value="">Select State</option>
            {states.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group mb-3">
          <select className="form-select" id="city" name="city" required>
            <option value="">Select City</option>
            {cities.map((city) => (
              <option key={city} value={city}>
                {city}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group mb-3">
          <select
            className="form-select"
            id="level"
            name="level"
            required
            onChange={(e) => fetchCourses(e.target.value)}
          >
            <option value="">Select Level</option>
            {levels.map((level) => (
              <option key={level} value={level}>
                {level}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group mb-3">
          <select className="form-select" id="course" name="course" required>
            <option value="">Select Course</option>
            {courses.map((course) => (
              <option key={course} value={course}>
                {course}
              </option>
            ))}
          </select>
        </div>
        <input type="hidden" name="current_url" value={window.location.href} />
        <input
          type="hidden"
          name="utm_source"
          value={
            new URLSearchParams(window.location.search).get("utm_source") || ""
          }
        />
        <input
          type="hidden"
          name="utm_medium"
          value={
            new URLSearchParams(window.location.search).get("utm_medium") || ""
          }
        />
        <input
          type="hidden"
          name="utm_campaign"
          value={
            new URLSearchParams(window.location.search).get("utm_campaign") ||
            ""
          }
        />
        <div className="form-group d-flex justify-content-center">
          <input
            type="submit"
            name="submit"
            value="Submit"
            className="btn btn-primary"
          />
        </div>
      </form>
    </div>
  );
}

export default LPEnquireForm;
